import React, { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";

const WarningDeleteModal = (props: any) => {
  const { data, title, message, isOpen, onDelete, onClose } = props;
  const [showDeletedConfirm, setShowDeletedConfirm] = useState(false);
  const [titleForm, setTitleForm] = useState<any>();
  const [messageLabel, setMessageLabel] = useState<any>();

  const handleDeletedConfirm = async () => {
    onDelete(data);
    handleCloseDeletedConfirm();
  };

  const handleCloseDeletedConfirm = () => {
    setShowDeletedConfirm(!isOpen);
    if (onClose) onClose();
  };

  useEffect(() => {
    if (isOpen) {
      setTitleForm(title);
      setMessageLabel(message);
    }
    setShowDeletedConfirm(isOpen);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  return (
    <Modal show={showDeletedConfirm} onHide={handleCloseDeletedConfirm}>
      <Modal.Header closeButton>
        <Modal.Title>{titleForm}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{messageLabel}</Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={handleCloseDeletedConfirm}>
          Không
        </Button>
        <Button variant="secondary" onClick={handleDeletedConfirm}>
          Đồng ý
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default WarningDeleteModal;
